import React, { useRef, useEffect } from "react";
import { Input } from "./ui/input";
import { Textarea } from "./ui/textarea";

function FormInput({
	label,
	field,
	value,
	dispatch,
	type = "text",
	step = "any",
	tooltip = "",
	actionType = "UPDATE_FIELD",
	index,
	subField,
	rows = 1,
	autoResize = false,
	required = false,
	disabled = false,
}) {
	const textareaRef = useRef(null);

	const handleChange = (e) => {
		if (actionType === "UPDATE_LINE_ITEM_FIELD") {
			// For line items, provide the index and specific field
			dispatch({
				type: actionType,
				index: index,
				field: subField,
				value: e.target.value,
			});
		} else {
			// For regular fields
			dispatch({
				type: actionType,
				field,
				value: e.target.value,
			});
		}

		// Auto-resize textarea if enabled
		if (autoResize && textareaRef.current) {
			const textarea = textareaRef.current;
			textarea.style.height = "auto";
			textarea.style.height = `${textarea.scrollHeight}px`;
		}
	};

	const handleFocus = (e) => {
		// For number inputs, select all text on focus for easy replacement
		if (type === "number") {
			e.target.select();
		}
	};

	// Auto-resize on initial render and value changes
	useEffect(() => {
		if (autoResize && textareaRef.current) {
			const textarea = textareaRef.current;
			textarea.style.height = "auto";
			textarea.style.height = `${textarea.scrollHeight}px`;
		}
	}, [value, autoResize]);

	return (
		<div className="form-group">
			<label htmlFor={field} className="form-label">
				{label}
				{required && <span className="required-indicator">*</span>}
				{tooltip && (
					<div className="tooltip-container">
						<span className="tooltip-icon">ⓘ</span>
						<span className="tooltip-text">{tooltip}</span>
					</div>
				)}
			</label>
			{type === "textarea" ? (
				<Textarea
					ref={textareaRef}
					id={field}
					name={field}
					value={value ?? ""}
					rows={rows}
					required={required}
					disabled={disabled}
					onChange={handleChange}
					style={{
						resize: autoResize ? "none" : "vertical",
						overflow: "hidden",
						minHeight: autoResize ? "40px" : "auto",
					}}
				/>
			) : (
				<Input
					type={type}
					id={field}
					name={field}
					value={value ?? ""}
					step={step}
					required={required}
					disabled={disabled}
					onChange={handleChange}
					onFocus={handleFocus}
				/>
			)}
		</div>
	);
}

export default FormInput;
